<script setup lang="ts">
import { computed, ref } from 'vue'
import type { UserSubscripiton } from '@/views/BillingView.vue'
import { myRequest } from '@/utils/fetch'

const addOn = false
const props = defineProps<{
  userSubscription: UserSubscripiton | null
  progress: number
  progressLabel: string
  remaining: number
}>()
const emits = defineEmits<(e: 'getSubscriptionInfo', next: () => void) => void>()
const loading = ref(false)

const startDate = computed(() => {
  const subscription = props.userSubscription
  if (!subscription) return null
  if (subscription.billingInterval === 'yearly' && subscription.lastUsageReset) {
    return new Date(subscription.lastUsageReset)
  }
  return new Date(subscription.current_period_start)
})

const endDate = computed(() => {
  const subscription = props.userSubscription
  if (!subscription) return null
  if (subscription.billingInterval === 'yearly') {
    const start = subscription.lastUsageReset
      ? new Date(subscription.lastUsageReset)
      : new Date(subscription.current_period_start)
    return new Date(start.setMonth(start.getMonth() + 1))
  }
  return new Date(subscription.current_period_end)
})

async function addProfiles() {
  loading.value = true
  await myRequest('POST', '/payments/addProfiles')
  emits('getSubscriptionInfo', () => {
    loading.value = false
  })
}

async function removeProfiles() {
  loading.value = true
  await myRequest('POST', '/payments/removeProfiles')
  emits('getSubscriptionInfo', () => {
    loading.value = false
  })
}
</script>

<template>
  <div class="col-12 col-md paddingFixerSingle">
    <div class="myCard q-pa-md full-height">
      <div class="row justify-between items-center">
        <div>
          <h6>Usage Statistics</h6>
          <p class="text-caption text-grey-6">
            {{
              startDate
                ? startDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
                : ''
            }}
            {{
              endDate
                ? ' - ' + endDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
                : ''
            }}
          </p>
        </div>
        <div>
          <span class="text-caption text-grey-6">{{ Math.round(progress * 100) }}% Used</span>
        </div>
      </div>
      <div class="column">
        <div class="row justify-between items-center">
          <span>{{ props.progressLabel }}</span>
          <span class="text-grey-6">{{ props.remaining }} remaining</span>
        </div>
        <q-linear-progress size="10px" dark rounded :value="props.progress" color="secondary" />
      </div>

      <div class="row justify-between" v-if="addOn">
        <q-btn
          @click="addProfiles"
          :class="props.userSubscription?.profileAddOn ? '' : 'full-width'"
          color="primary"
          label="Add 80 more profiles for $5"
          :loading="loading"
        />
        <q-btn
          v-if="props.userSubscription?.profileAddOn"
          @click="removeProfiles"
          color="negative"
          label="Remove 80 profiles"
          :loading="loading"
        />
      </div>
    </div>
  </div>
</template>
